import { render } from "./DoctorProfileForm.vue?vue&type=template&id=486f2314&scoped=true"
import script from "./DoctorProfileForm.vue?vue&type=script&lang=js"
export * from "./DoctorProfileForm.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./DoctorProfileForm.vue?vue&type=style&index=1&id=486f2314&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-486f2314"]])

export default __exports__